module.exports = __webpack_public_path__ + "5038a780cb1e79f2879e31a5c8d9713c.MP3";